/** Extracts the name from Core audit descriptions, preserving unfamiliar values. */
export const getAuditActorName = (value: string | null | undefined): string | null | undefined => {
  if (value == null) return value;

  const match = /^Attempt by\s+(.+?)\s*\(\d+\)-[A-Z_]+-USER$/.exec(value.trim());
  return match?.[1]?.trim() || value;
};
